export function appendStyle (styles: string) {
	const styleElement = document.createElement('style');
	styleElement.innerHTML = styles;
	document.head.appendChild(styleElement);
}
